module.exports = __webpack_public_path__ + "img/Frame-23.8e6e1d83.svg";